import { render, staticRenderFns } from "./WaveLoader.vue?vue&type=template&id=b8c7b59a&scoped=true"
import script from "./WaveLoader.vue?vue&type=script&lang=js"
export * from "./WaveLoader.vue?vue&type=script&lang=js"
import style0 from "./WaveLoader.vue?vue&type=style&index=0&id=b8c7b59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c7b59a",
  null
  
)

export default component.exports